import type {ExamModule} from '@cp/model';
import type {UpdateData} from 'firebase/firestore';
import {updateDoc} from 'firebase/firestore';
import getExamModuleDocRef from './getExamModuleDocRef';

export default async function updateExamModuleDoc(examModule: ExamModule): Promise<void> {
  await updateDoc(getExamModuleDocRef(examModule.id), examModule as unknown as UpdateData<object>);
}
